module.exports = __webpack_public_path__ + "img/upload.bc46570b.jpg";